/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_Opacity_Aria_LabelInputs */

const en_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary Opacity`)
};

const fr_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite secondaire`)
};

const de_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekundäre Opazität`)
};

const it_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità secondaria`)
};

const ru_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вторичная непрозрачность`)
};

const es_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad secundaria`)
};

const zh_cn2_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继发性不透明度`)
};

const ja_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二次不透明度`)
};

const hi_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वितीयक अपारदर्शिता`)
};

const pt_pt2_styles_secondary_opacity_aria_label = /** @type {(inputs: Styles_Secondary_Opacity_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade secundária`)
};

/**
* | output |
* | --- |
* | "Secondary Opacity" |
*
* @param {Styles_Secondary_Opacity_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_opacity_aria_label = /** @type {((inputs?: Styles_Secondary_Opacity_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_Opacity_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_secondary_opacity_aria_label(inputs)
	if (locale === "de") return de_styles_secondary_opacity_aria_label(inputs)
	if (locale === "it") return it_styles_secondary_opacity_aria_label(inputs)
	if (locale === "ru") return ru_styles_secondary_opacity_aria_label(inputs)
	if (locale === "es") return es_styles_secondary_opacity_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_secondary_opacity_aria_label(inputs)
	if (locale === "ja") return ja_styles_secondary_opacity_aria_label(inputs)
	if (locale === "hi") return hi_styles_secondary_opacity_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_secondary_opacity_aria_label(inputs)
	return en_styles_secondary_opacity_aria_label(inputs)
});